/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupSmsTemplatesRoutingModule } from './builder-setup-sms-templates-routing.module';
import { SmsTemplateDetailsComponent } from './components/sms-template-details/sms-template-details.component';
import { SmsTemplatePreviewDialogComponent } from './components/sms-template-details/sms-template-preview-dialog/sms-template-preview-dialog.component';
import { SmsTemplateListComponent } from './components/sms-template-list/sms-template-list.component';
import { SmsTemplateDetailsBusinessService } from './resources/sms-template-details-business.service';
import { SmsTemplateListBusinessService } from './resources/sms-template-list-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupSmsTemplatesRoutingModule,
  ],
  providers: [
    SmsTemplateDetailsBusinessService,
    SmsTemplateListBusinessService,
  ],
  declarations: [
    SmsTemplateDetailsComponent,
    SmsTemplateListComponent,
    SmsTemplatePreviewDialogComponent,
  ],
})
export class BuilderSetupSmsTemplatesModule {
}
